import React, { useState, useEffect } from 'react';
import { IState, ReduxMap } from '../../redux/redux';
import { IDashboardInfo, WarningDataLevel } from './DashboardTypes';
import Icon, { IconType } from '../Icon/Icon';
import { store } from '../../redux/oldStore';
import { toast } from 'react-toastify';
import MyChart from '../Chart/MyChart';
import Modal from '../Modal/Modal';
import SetupWizard from '../Setup/SetupWizard';
import BranchPortal from '../Setup/Branches/BranchPortal';
// import { Pie } from 'react-chartjs-2';

interface IProps extends IState {}

const Dashboard = (props: IProps) => {
  const [data, setData] = useState<IDashboardInfo>();
  const [showBranches, setShowBranches] = useState<boolean>(false);
  const [branchId, setBranchId] = useState<string>('');
  const [branchName, setBranchName] = useState<string>('');

  useEffect(() => {
    init();
  }, []);

  const init = () => {
    store.server.getApi2<IDashboardInfo>(`../StaffDashboard/Info`).then((x) => {
      if (x.Success) {
        setData(x.Value);
      } else {
        toast.error(x.Message, { autoClose: false });
      }
    });
  };

  const OpenBranch = (id: string, name: string) => {
    setBranchId(id);
    setBranchName(name);
    setShowBranches(true);
  };

  const renderWarnings = () => {
    return (
      <>
        {data && data.warnings && data.warnings.length > 0 && (
          <>
            <div className="warning-panel">
              <h3>Messages</h3>
              <ul className="">
                {data.warnings.map((x, i) => {
                  let header = <strong>Warning:</strong>;
                  switch (x.Level) {
                    case WarningDataLevel.Warning:
                      header = <strong className="label label-warning">Warning</strong>;
                      break;
                    case WarningDataLevel.Info:
                      header = <strong className="label label-info">Info</strong>;
                      break;
                    case WarningDataLevel.Critical:
                      header = <strong className="label label-danger">Critical</strong>;
                      break;
                    case WarningDataLevel.New:
                      header = (
                        <strong className="label label-success">
                          <Icon type={IconType.stars} /> New
                        </strong>
                      );
                      break;
                  }

                  return (
                    <li key={i}>
                      {header}

                      {x.Link && (
                        <a href={x.Link} className="link" target={x.Target ?? '_self'} rel="noreferrer">
                          {x.LinkText}
                        </a>
                      )}
                      {x.BranchId && (
                        <a
                          onClick={() => {
                            OpenBranch(x.BranchId, x.LinkText ?? 'View Branch');
                            return false;
                          }}
                          className="link">
                          {x.LinkText ?? 'View Branch'}
                        </a>
                      )}
                      <div dangerouslySetInnerHTML={{ __html: x.Text }}></div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </>
        )}
      </>
    );
  };

  return (
    <>
      <div className="dashboard">
        <div className="stats">
          <div className="flex-centered wrap gap-2">
            {data && (
              <>
                {data.orderStats && data.orderStats.length > 0 && (
                  <div>
                    <h3>Order Stats</h3>
                    <MyChart
                      size="small"
                      type="doughnut"
                      data={{
                        labels: data.orderStats.map((x) => x.Label),
                        datasets: [{ data: data.orderStats.map((x) => x.Value), label: 'Order Stats' }],
                      }}
                    />
                  </div>
                )}
                {data.entryStats && data.entryStats.length > 0 && (
                  <div>
                    <h3>Entry Type Stats</h3>
                    <MyChart
                      size="small"
                      type="doughnut"
                      data={{
                        labels: data.entryStats.map((x) => x.Label),
                        datasets: [{ data: data.entryStats.map((x) => x.Value), label: 'Entry Types' }],
                      }}
                    />
                  </div>
                )}
                {data.categoryStats && data.categoryStats.length > 0 && (
                  <div>
                    <h3>Category Stats</h3>
                    <MyChart
                      size="small"
                      type="doughnut"
                      data={{
                        labels: data.categoryStats.map((x) => x.Label),
                        datasets: [{ data: data.categoryStats.map((x) => x.Value), label: 'Categories' }],
                        //datasets: data.categoryStats.map((x) => ({ data: [x.Value], label: x.Label })),
                      }}
                    />
                  </div>
                )}
                {data.genderStats && data.genderStats.length > 0 && (
                  <div>
                    <h3>Gender Stats</h3>
                    <MyChart
                      size="small"
                      type="doughnut"
                      data={{
                        labels: data.genderStats.map((x) => x.Label),
                        datasets: [{ data: data.genderStats.map((x) => x.Value), label: 'Genders' }],
                      }}
                    />
                  </div>
                )}
                {data.gradeStats && data.gradeStats.length > 0 && (
                  <div>
                    <h3>Grade Stats</h3>
                    <MyChart
                      size="small"
                      type="doughnut"
                      data={{
                        labels: data.gradeStats.map((x) => x.Label),
                        datasets: [{ data: data.gradeStats.map((x) => x.Value), label: 'Grades' }],
                      }}
                    />
                  </div>
                )}
              </>
            )}
          </div>
        </div>
        <div className="dash-main">
          {renderWarnings()}
          {data && data.quickAccess && data.quickAccess.length > 0 && (
            <>
              <div className="quick-access-panel">
                <h3>Quick Access</h3>
                <div className="quick-access-list">
                  {data.quickAccess.map((x, i) => (
                    <div key={i} className={`quick-access ${x.ClassName}`}>
                      <h3>
                        <Icon type={x.Icon} />
                        {x.Label}
                      </h3>
                      {x.Description && <div dangerouslySetInnerHTML={{ __html: x.Description }}></div>}
                      {x.Link && (
                        <a href={x.Link} className={`btn btn-secondary`} target={x.Target ?? '_self'} rel="noreferrer">
                          <Icon type={x.Icon} /> {x.LinkText ?? ''}
                        </a>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}
          {!data && (
            <div>
              <h2>
                <Icon type={IconType.dashboard} /> Dashboard
              </h2>
            </div>
          )}
        </div>
      </div>
      {showBranches && branchId && <Modal title={branchName} setModalOpen={setShowBranches} size="xl">
        <BranchPortal publicId={branchId} />
        </Modal>}
    </>
  );
};
export default ReduxMap(Dashboard);
